export default __webpack_public_path__ + "static/about-jellow-bg-min-f1f6486fc860554c8c5bf2e26e498dff.png";